import { createAction, props } from '@ngrx/store';
import {OrganizationAccounts} from '../../models/organisationAccounts';
export enum OrganizationActionTypes {
    initOrganization = '[Org] init organization',
    getOrganization = '[Org] get organization',
    getOrganizationSuccess = '[Org] get organization success',
    getOrganizationFailure = '[Org] get organization failure',
    clearOrganization = '[Org] clear organization',
}
export const InitOrganization = createAction(OrganizationActionTypes.initOrganization);
export const GetOrganization = createAction(OrganizationActionTypes.getOrganization, props<{ organizationId: string }>());
export const GetOrganizationSuccess = createAction(OrganizationActionTypes.getOrganizationSuccess, props<any>());
export const GetOrganizationFailure = createAction(OrganizationActionTypes.getOrganizationFailure, props<any>());
export const SearchOrganizations = createAction('[Org] search organizations', props<{ searchTerm: string, email: string, password: string}>());
export const SearchOrganizationSuccess = createAction('[Org] search organizations success', props<{ searchedOrganizations: OrganizationAccounts[] }>());
export const ClearSearchOrganization = createAction('[Org] clear searched organizations')
export const ClearOrganization = createAction(OrganizationActionTypes.clearOrganization);
